var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column align-items-center justify-content-center mb-3"},[_c('b-spinner',{staticClass:"m-5",staticStyle:{"width":"4rem","height":"4rem"},attrs:{"label":"Loading..."}}),_c('div',{staticClass:"m-4"},[_vm._v("Loading...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }